import { useClinicRepository } from '@/repositories/clinicRepo'
import { useAppStore } from '@/stores/AppStore'
import { showNotify } from 'vant/es/notify/function-call'
import { closeToast, showLoadingToast } from 'vant/es/toast/function-call'

// TODO: ย้าย patient จาก AppStore มาเป็น PatientStore แยกต่างหาก
export const usePatientMiniInfo = () => {
  const appStore = useAppStore()
  const clinicRepo = useClinicRepository(appStore.clinicUUID)

  // Initialize patient data
  const initPatient = async () => {
    if (appStore.patient) return appStore.patient

    showLoadingToast({
      message: 'กำลังโหลดข้อมูลผู้ใช้...',
      forbidClick: true,
      duration: 0,
    })

    try {
      const patientData = await clinicRepo.fetchPatientMiniInfo()
      appStore.setPatient(patientData)
      closeToast()
      return patientData
    } catch (error) {
      console.error('Error fetching patient:', error)
      closeToast()
      showNotify({
        type: 'danger',
        message: 'ไม่สามารถโหลดข้อมูลผู้ใช้ได้ กรุณาลองใหม่อีกครั้ง',
        duration: 5000,
      })
      return null
    }
  }

  return {
    initPatient,
  }
}
